import { css } from 'styled-components';
import {
  getSpacing, SpacingName, TypographyName, getTypography, ThemedFunctor,
} from '@doveit/bricks';

export const rapidLinksTitle: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.H4)}
  ${getSpacing.marginBottom(theme, SpacingName.SMALL)}
`;

export const rapidLinksItem: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}

  > a {
    color: ${theme.palettes.neutrals.darkest};
  }

  &:first-of-type {
    margin-top: 0;
  }
`;
